export const getLinkToAndDisplay = (resourceName, record) => {
  switch (resourceName) {
    case 'StatePositionRateSetting':
      if (record.state_position_rate_setting_id) {
        return {
          display: 'Update',
          linkTo: `/StatePositionRateSetting/${record.state_position_rate_setting_id}`,
        };
      }
      return {
        display: 'Create Custom',
        linkTo: '/StatePositionRateSetting/create',
      };

    case 'StateLocationTypePositionRateSetting':
      if (record.state_location_type_position_rate_setting_id) {
        return {
          display: 'Update',
          linkTo: `/StateLocationTypePositionRateSetting/${record.state_location_type_position_rate_setting_id}`,
        };
      }
      return {
        display: 'Create Custom',
        linkTo: '/StateLocationTypePositionRateSetting/create',
      };

    case 'MarketLocationTypePositionRateSetting':
      if (record.market_location_type_position_rate_setting_id) {
        return {
          display: 'Update',
          linkTo: `/MarketLocationTypePositionRateSetting/${record.market_location_type_position_rate_setting_id}`,
        };
      }
      if (record.market_position_rate_setting_id) {
        return {
          display: 'Update',
          linkTo: `/MarketPositionRateSetting/${record.market_position_rate_setting_id}`,
        };
      }
      return {
        display: 'Create Custom',
        linkTo: '/MarketPositionRateSetting/create',
      };

    case 'LocationPositionRateSetting':
      if (record.location_position_rate_setting_id) {
        return {
          display: 'Update',
          linkTo: `/LocationPositionRateSetting/${record.location_position_rate_setting_id}`,
        };
      }
      return {
        display: 'Create Custom',
        linkTo: '/LocationPositionRateSetting/create',
      };

    default:
      return {
        display: 'Create',
        linkTo: `/${resourceName}/create`,
      };
  }
};

export const getCreateLinkTo = (resourceName, resource) => {
  if (resource === 'Market') {
    return `/MarketPositionRateSetting/create`;
  }

  if (resource === 'State') {
    return `/StatePositionRateSetting/create`;
  }

  return `/${resourceName}/create`;
};
